<template>
  <div>
    <div class="kt-login-v2__title">
      <h3>Tweestapsverificatie (2FA)</h3>
    </div>

    <div class="kt-login-v2__form kt-form pt-3 d-flex justify-content-center">
      <div style="max-width: 500px;">
        <p>
          Beste gebruiker,
          <br><br>
          <i>Tweestapsverificatie (2FA)</i> is ingeschakeld voor je account.
          <br><br>
          Bij het inloggen zal je naast je wachtwoord ook een unieke code moeten invoeren die, via <b>Google Authenticator</b>, op je telefoon gegenereerd wordt.
        </p>

        <div class="kt-login-v2__actions mt-4 justify-content-end">
          <button
            class="btn btn--primary"
            @click="page = AuthPage.TWO_FACTOR_AUTH_INFO;"
          >
            <span>Volgende</span>
            <i class="fas fa-chevron-right pl-2"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'

const { page } = storeToRefs(useAuthStore())
</script>

